module.exports = __webpack_public_path__ + "static/media/Dusknoir_gaussian2.eead6976.png";